<template>
  <div class="page-spring-course-2020">
    <div class="banner">
      <ym-img v-if="banner !== ''"
              class="head-img"
              :src="banner"
              alt="封面图"
      />
    </div>
    <div class="info-block">
      <count-down v-if="countDown"
                  class="count-down"
                  :start="countDown.startTime"
                  :end="countDown.endTime"
                  :block-bg-img="getBlockBgImg"
                  :item-bg-img="getItemBgImg"
                  @count-down-ended="handleCountDownEnded"
      />
    </div>
    <div class="course">
      <div class="survey">
        <img class="survey-head"
             :src="require('@/pages/2020/MayCourse/assets/img/survey.png')"
             alt="课程概况"
        />
        <div class="survey-item"
             v-for="(item, index) in survey"
             :key="index"
        >
          <img class="survey-img"
               :src="item.img"
               alt=""
          />
          <div class="survey-text">{{ item.text }}</div>
        </div>
      </div>
      <div class="specialities">
        <img class="specialities-head"
             :src="require('@/pages/2020/MayCourse/assets/img/specialities.png')"
             alt="六大特色"
        />
        <div class="specialities-block">
          <div class="specialities-item"
               v-for="(item, index) in specialities"
               :key="index"
          >
            <img class="specialities-img"
                 :src="item.img"
                 alt=""
            >
            <div class="specialities-content">
              <div class="specialities-title">{{ item.title }}</div>
              <div class="specialities-text">{{ item.describe }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="live-course">
        <img class="course-head"
             :src="require('@/pages/2020/MayCourse/assets/img/liveCourse.png')"
             alt="八大系列视频直播课"
        />
        <div class="course-block">
          <div class="course-title">
            <span>*任何地方孩子均可报名，点击</span>
            <span class="red">任意主题</span>
            <span>可查看详情</span>
          </div>
          <div class="form-title">
            <div class="college">主题</div>
            <div class="course-series">视频直播课</div>
            <div class="age">适合年龄</div>
          </div>
          <div class="college-item"
               v-for="(item, index) in schedules"
               :key="index"
          >
            <div class="college-name">{{ item.collegeName }}</div>
            <div class="product-list">
              <div class="product-item"
                   v-for="(productItem, productIndex) in item.courseList"
                   :key="productIndex"
                   v-ym-report:MARKETING_MAY_SPRING_COURSE_2020_TABLE_CLICK="{ id: productItem.id }"
              >
                <router-link class="item-title"
                             :to="productItem.productPath"
                             :target="target"
                             v-html="productItem.title"
                />
                <div class="item-age">{{ productItem.age }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="harvest">
        <img class="harvest-head"
             :src="require('@/pages/2020/MayCourse/assets/img/harvest.png')"
             alt=""
        />
        <div class="harvest-block">
          <div class="harvest-item"
               v-for="(item, index) in harvest"
               :key="index"
          >
            <div class="harvest-title">{{ item.title }}</div>
            <div class="harvest-content">{{ item.content }}</div>
          </div>
        </div>
      </div>
    </div>
    <member-review-video v-if="video"
                         :poster="video.src"
                         :src="video.url"
                         :status="render.status"
    />
    <product-list v-if="products.length > 0"
                  :list="products"
                  :status="render.status"
    />
    <question-list v-if="faq"
                   :replay-url="faq.url"
                   :status="render.status"
    />
    <div v-if="!isAppWebView() && inH5Platform"
         class="download-app-block"
    >
      <router-link to="https://m.youthmba.com/download/app">
        <img class="download-app-btn"
             :src="require('@/pages/2020/MayCourse/assets/img/download.png')"
             alt="点击下载App"
        />
      </router-link>
    </div>
    <div v-if="inH5Platform"
         class="contact-us"
    >
      <div class="tel">
        <a class="external" href="tel:4008093885">电话咨询</a>
      </div>
    </div>
  </div>
</template>

<script>
  import CountDown from '@/components/CountDown';
  import getMayCourseInfo from '@/services/may-course-2020';
  import MemberReviewVideo from '@/pages/2020/MayCourse/components/MemberReviewVideo';
  import ProductList from '@/pages/2020/MayCourse/components/ProductList';
  import QuestionList from '@/pages/2020/MayCourse/components/QuestionList';
  import { isWeiXinBrowser, isPC, isAppWebView } from '@/utils';

  export default {
    name: 'MayCourse2020',
    components: {
      CountDown,
      MemberReviewVideo,
      ProductList,
      QuestionList,
    },
    data() {
      return {
        countDown: null,
        qrCode: null,
        video: null,
        products: [],
        schedules: [],
        welfare: null,
        faq: null,
        render: {
          status: '',
        },
        banner: '',
        /* eslint-disable global-require */
        survey: [
          {
            text: '四大学院八大主题',
            img: require('@/pages/2020/MayCourse/assets/img/firstSurvey.png'),
          },
          {
            text: '包含4次国际化直播课程',
            img: require('@/pages/2020/MayCourse/assets/img/secondSurvey.png'),
          },
          {
            text: '导师皆毕业于世界名校',
            img: require('@/pages/2020/MayCourse/assets/img/thirdSurvey.png'),
          },
          {
            text: '精美主题工具包与学习证书快递到家',
            img: require('@/pages/2020/MayCourse/assets/img/fourthSurvey.png'),
          },
        ],
        specialities: [
          {
            title: '趣味性',
            describe: '哈佛案例教学法活泼生动',
            img: require('@/pages/2020/MayCourse/assets/img/firstSpecialities.png'),
          },
          {
            title: '双师制',
            describe: '全程班主任个性化答疑',
            img: require('@/pages/2020/MayCourse/assets/img/secondSpecialities.png'),
          },
          {
            title: '混合制',
            describe: '直播后自主完成创意实践挑战',
            img: require('@/pages/2020/MayCourse/assets/img/thirdSpecialities.png'),
          },
          {
            title: '自驱力',
            describe: '激发多学科兴趣与自主学习力',
            img: require('@/pages/2020/MayCourse/assets/img/fourthSpecialities.png'),
          },
          {
            title: '游戏化',
            describe: '作品获专业点评与勋章激励',
            img: require('@/pages/2020/MayCourse/assets/img/firthSpecialities.png'),
          },
          {
            title: '档案式',
            describe: '建立专属成长档案',
            img: require('@/pages/2020/MayCourse/assets/img/sixthSpecialities.png'),
          },
        ],
        /* eslint-enable global-require */
        harvest: [
          {
            title: '1、跨学科学习法与自主学习力',
            content: '视野更开阔，思维更活跃，让孩子爱上学习',
          },
          {
            title: '2、掌握创新思维方法',
            content: '学会从不同角度独立思考问题，解决问题',
          },
          {
            title: '3、提升演讲表达能力与自信心',
            content: '课程与创意实践，锻炼逻辑思维，提升气场',
          },
          {
            title: '4、为升学留学弯道超车提前做准备 ',
            content: '关注趋势变化，提升面向未来的核心竞争力',
          },
        ],
      };
    },
    computed: {
      target() {
        return isPC() ? '_blank' : '_self';
      },
      /* eslint-disable global-require */
      getBlockBgImg() {
        return require('@/pages/2020/MayCourse/assets/img/count_down_block.png');
      },
      getItemBgImg() {
        return require('@/pages/2020/MayCourse/assets/img/countDownItem.png');
      },
      /* eslint-enable global-require */
      showQrCode() {
        return isWeiXinBrowser();
      },
      inH5Platform() {
        return !isPC();
      },
      inPC() {
        return isPC();
      },
    },
    methods: {
      isAppWebView,
      async fetchData() {
        const data = await getMayCourseInfo();
        this.banner = data.banner;
        this.countDown = data.countDown;
        this.schedules = data.schedules;
        this.video = data.video;
        this.render = data.render;
        this.products = data.products;
        this.faq = data.faq;
      },
      handleCountDownEnded() {
        this.countDown = null;
      },
    },
    created() {
      this.fetchData();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-spring-course-2020 {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: @color-white;
    color: #333;
    box-sizing: border-box;
  }

  .banner {
    height: 470px;
    position: relative;
    display: flex;
    justify-content: center;
    .head-img {
      display: block;
      width: 100%;
      height: 100%;
    }
    .banner-title {
      position: absolute;
      bottom: 112px;
      min-width: 500px;
      height: 46px;
      padding: 0 40px;
      background: #f9e114;
      color: @color-black-dark;
      font-weight: @font-weight-strong;
      line-height: 46px;
      border: 2px solid #6ec03a;
      border-radius: 24px;
      text-align: center;
    }
  }

  .info-block {
    background: #c3e8e7;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding-bottom: @size-extra-medium;
    .count-down {
      height: 200px;
      width: 626px;
      margin-top: -36px;
    }
  }

  .content {
    margin-top: 60px;
    width: 626px;
    border: 5px solid #6ec03a;
    background: @color-white;
    box-sizing: border-box;
    border-radius: 10px;
    .text {
      padding: 42px 0;
      text-align: center;
      font-size: 26px;
      line-height: 50px;
      font-weight: @font-weight-strong;
      .high-light {
        color: #00a83b;
        font-weight: @font-weight-bold;
      }
    }
  }

  .course {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 70px;
    .survey {
      padding: 0 80px;
      margin-bottom: 70px;
      .survey-head {
        display: block;
        width: 230px;
        height: 62px;
        margin-bottom: 34px;
      }
      .survey-item {
        width: 590px;
        height: 72px;
        margin-bottom: 6px;
        position: relative;
        .survey-img {
          width: 100%;
          height: 100%;
        }
        .survey-text {
          position: absolute;
          left: 90px;
          top: 18px;
        }
      }
    }
    .specialities {
      box-sizing: border-box;
      margin-bottom: 98px;
      padding: 0 60px;
      .specialities-head {
        display: block;
        margin-left: 20px;
        width: 296px;
        height: 70px;
      }
      .specialities-block {
        margin-top: 14px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        width: 100%;
      }
      .specialities-item {
        margin-bottom: 30px;
        height: 300px;
        width: 200px;
        position: relative;
        .specialities-img {
          position: absolute;
          top: 0;
          left: 50%;
          margin-left: -50px;
          width: 100px;
          height: 100px;
          z-index: 1;
        }
        .specialities-content {
          position: absolute;
          bottom: 0;
          height: 240px;
          width: 100%;
          border-radius: 20px;
          background: #b8f2f0;
          display: flex;
          flex-direction: column;
          align-items: center;
          .specialities-title {
            margin-top: 50px;
            font-size: 28px;
            font-weight: @font-weight-bold;
            color: #2284b2;
          }
          .specialities-text {
            margin-top: 30px;
            width: 180px;
            font-size: @font-size-small;
            line-height: 42px;
            text-align: center;
            color: #333333;
          }
        }
      }
    }
    .live-course {
      box-sizing: border-box;
      width: 700px;
      .course-head {
        display: block;
        height: 70px;
        margin-left: 56px;
      }
      .course-block {
        .course-title {
          margin: 24px 0 24px 44px;
          color: #4d311c;
          font-size: 26px;
          font-weight: @font-weight-bold;
          .red {
            color: #ff0000;
          }
        }
        .form-title {
          display: flex;
          .college {
            padding: 30px 0 30px 0;
            width: 130px;
            border: 1px solid #2284b2;
            border-top-left-radius: 10px;
            border-right: transparent;
            text-align: center;
            color: #2284b2;
            background: #c3e8e7;
          }
          .course-series {
            padding: 30px 0 30px 0;
            width: 410px;
            border: 1px solid #2284b2;
            box-sizing: border-box;
            border-right: transparent;
            text-align: center;
            color: #2284b2;
            background: #c3e8e7;
          }
          .age {
            box-sizing: border-box;
            padding: 30px 0 30px 0;
            width: 160px;
            border: 1px solid #2284b2;
            text-align: center;
            border-top-right-radius: 10px;
            color: #2284b2;
            background: #c3e8e7;
          }
        }
        .college-item {
          display: flex;
          &:last-child {
            .college-name {
              border-bottom-left-radius: 10px;
            }
            .product-item {
              &:last-child .item-age {
                border-bottom-right-radius: 10px;
              }
            }
          }
          .college-name {
            width: 130px;
            border: 1px solid #2284b2;
            border-right: transparent;
            border-top: transparent;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .product-list {
            .product-item {
              display: flex;
              .item-title {
                padding: @size-base @size-small;
                box-sizing: border-box;
                border: 1px solid #2284b2;
                border-top: transparent;
                border-right: transparent;
                width: 410px;
                font-weight: @font-weight-bold;
                position: relative;
                span {
                  border-bottom: 1px solid @color-highlight;
                }
              }
            }
            .item-age {
              box-sizing: border-box;
              border: 1px solid #2284b2;
              border-top: transparent;
              width: 160px;
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }
        }
      }
    }
    .harvest {
      margin-top: 48px;
      width: 100%;
      .harvest-head {
        display: block;
        width: 254px;
        height: 68px;
        margin: 0 0 14px 78px;
      }
      .harvest-block {
        .harvest-item:not(:last-child) {
          margin-bottom: 60px;
        }
        width: 100%;
        background: fade(#a7f1ef, 20%);
        padding: 40px 0 48px 90px;
        box-sizing: border-box;
        .harvest-item {
          .harvest-title {
            color: #2284b2;
            font-size: 26px;
            font-weight: @font-weight-bold;
          }
          .harvest-content {
            font-size: 26px;
          }
        }
      }
    }
  }

  .welfare {
    margin-bottom: 60px;
    position: relative;
    width: 682px;
    height: 864px;
    .calendar {
      width: 100%;
      height: 100%;
    }
  }

  .calendar-info-block {
    position: absolute;
    top: 102px;
    left: 76px;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: @color-text-base;
    font-size: 30px;
    .red {
      color: #ff3817;
      font-size: 40px;
      font-weight: @font-weight-bold;
    }
    .hint {
      color: @color-text-light;
      font-size: 26px;
    }
  }

  .calendar-desc {
    position: absolute;
    text-align: right;
    color: #1aaead;
    font-size: 30px;
    bottom: 126px;
    right: 50px;
  }

  .contact-us {
    position: fixed;
    bottom: 0;
    z-index: 1;
    width: 100%;
    height: 110px;
    line-height: 110px;
    font-size: 28px;
    background: linear-gradient(0deg, #3594ff 0%, #64e5e3 100%);
    color: @color-white;
    display: flex;
    text-align: center;
    a {
      color: @color-white;
      width: 100%;
      height: 110px;
      display: block;
    }
    .tel {
      flex: 1;
      position: relative;
      &:after {
        position: absolute;
        right: 0;
        top: 15px;
        width: 1px;
        height: 80px;
        content: '';
        background-color: fade(@color-white, 50%);
      }
    }
    .qr-code {
      flex: 1;
    }
  }

  .vip-benefit {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 392px;
    width: 620px;
    background-image: url('~@/pages/2020/SpringCourse/assets/img/vipBenefitBg.png');
    background-size: cover;
    margin: -@size-base 0 @size-medium;
    .benefit-title {
      margin: 118px 0 10px;
      border: 1px solid #178bdc;
      border-radius: 18px;
      font-size: @font-size-small;
      color: @color-black-dark;
      padding: 0 30px;
    }
    .benefit-des {
      font-size: @font-size-base;
      color: @color-black-dark;
    }
    .benefit-price {
      font-size: 38px;
      color: #f33b10;
      font-weight: bold;
    }
    .del-price {
      text-decoration: line-through;
      font-size: @font-size-small;
      color: @color-black-dark;
      margin-bottom: @size-medium;
    }
    .vip-entry {
      width: 334px;
      height: 70px;
      text-align: center;
      line-height: 70px;
      background: linear-gradient(0deg, #fd7c2a, #ffd461);
      border: 2px solid #ece6e6;
      border-radius: 36px;
      color: #e42b12;
      font-size: @font-size-medium;
      font-weight: @font-weight-bold;
    }
  }
  .download-app-block {
    width: 100%;
    padding: 100px 0 170px 0;
    img {
      width: 100%;
      display: block;
    }
  }
</style>
